import service from '@/utils/server';

const modName='/bd/collection/';
//查询方法
export const pageInfo = data => {
  return service({
    url: modName + 'pageInfo',
    method: 'post',
    data
  });
};

export const exportData = data => {
  return service({
    url: modName + 'exportPaymentDetails',
    method: 'post',
    responseType: 'blob',
    data
  });
};

export const detail = data => {
  return service({
    url: modName + 'detail',
    method: 'post',
    data
  });
};

export const download = data => {
  return service({
    url: modName + 'downloadAnnex',
    method: 'post',
    responseType: 'blob',
    data
  });
};

export const batchDownload = data => {
  return service({
    url: modName + 'batchDownloadAnnex',
    method: 'post',
    responseType: 'blob',
    data
  });
};

export const bankDetail = data => {
  return service({
    url: modName + 'bankDetail',
    method: 'post',
    data
  });
};


export const updateBankSubmit = data => {
  return service({
    url: modName + 'updateBankSubmit',
    method: 'post',
    data
  });
};

export const noticeAfreshBindSubmit = data => {
  return service({
    url: modName + 'noticeAfreshBind',
    method: 'post',
    data
  });
};



// WEBPACK FOOTER //
// ./src/page/bd/run/collection/api/index.js